import { render, staticRenderFns } from "./hospitality.vue?vue&type=template&id=ed4e7c34&"
import script from "./hospitality.vue?vue&type=script&lang=js&"
export * from "./hospitality.vue?vue&type=script&lang=js&"
import style0 from "./hospitality.vue?vue&type=style&index=0&id=ed4e7c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports